//TODO: typings
export function getSelectedLayerTimes() {
    const activeComposition = app.project && app.project.activeItem && app.project.activeItem instanceof CompItem ? app.project.activeItem : null
    const selectedLayerTimes: object[] = []
    if (activeComposition && <[]>activeComposition?.selectedLayers) {
        for (let i = 0; i < activeComposition.selectedLayers.length; i++) {
            let obj = { index: 0, time: 0, frameRate: 0}
            obj.index = activeComposition.selectedLayers[i].index
            obj.time = activeComposition.selectedLayers[i].inPoint
            obj.frameRate = activeComposition.frameRate
            selectedLayerTimes.push(obj)
        }
    }
    return selectedLayerTimes
}
//AE layers are 1-indexed
//User selected layer array is 0 indexed and can contain any contiguous range of layers  
export function moveLayers(req: any, sortedLayerArr: any) {
    var myComp = app.project.activeItem;
    if (myComp) {
        for (var i = 0; i < sortedLayerArr.length; i++) {
            //@ts-ignore
            myComp.layer(sortedLayerArr[i].index).startTime = req[i] * myComp.frameDuration;
        }
    }
}

export function getSelectedLayers() {
    var activeComposition = app.project && app.project.activeItem && app.project.activeItem instanceof CompItem ? app.project.activeItem : null;
    let active = activeComposition?.selectedLayers;
    return active
}
  